// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;Remember not against us our former sins;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;let your compassion make haste to meet us,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;for we are brought very low.<br> </p> </div></div>";
// Exports
module.exports = code;